module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-7.jpg?v=56a0f0a6";